import React from "react"
import Layout from "../components/layout"
import SVG from "../components/svg/svg"

export default function About() {
  return (
    <div style={{ color: `teal` }}>
      <Layout>
      <SVG />
      </Layout>
      
    </div>
  )
}